var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"party"},[_c('my-banner',{attrs:{"banner":_vm.banner,"nav":[]}}),_c('my-notice',{attrs:{"id":4}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }